import { useMutation } from '@tanstack/react-query';
import { queryClient } from 'src/components/queryProvider';
import { IUpdateLocation } from 'src/interfaces';
import { queryKeys, requestCCApi } from 'src/utils';

export const useUpdateLocation = () => {
  return useMutation({
    mutationFn: updateLocation,
    onSuccess() {
      queryClient.refetchQueries(queryKeys.locations.invalidateAll());

      queryClient.refetchQueries(queryKeys.locationOwnerTags.invalidateAll());
      queryClient.refetchQueries(queryKeys.locationTags.invalidateAll());
      queryClient.refetchQueries(queryKeys.locationListing.invalidateAll());
      queryClient.invalidateQueries({
        queryKey: queryKeys.viewLocations.invalidateAll(),
        refetchType: 'none',
      });
      queryClient.invalidateQueries({
        queryKey: queryKeys.viewLocationsByGroups.all(),
        refetchType: 'none',
      });
    },
  });
};

const updateLocation = async (payload: IUpdateLocation) => {
  const { location_code, ...payloadWithoutLocationCode } = payload;

  const data = {
    data: payloadWithoutLocationCode,
  };

  const response = await requestCCApi({
    url: `/locations/${location_code}`,
    method: 'PATCH',
    data: data,
  });

  return response;
};
